import { render } from "./Component-Select.vue?vue&type=template&id=bfd8d940&scoped=true"
import script from "./Component-Select.vue?vue&type=script&lang=js"
export * from "./Component-Select.vue?vue&type=script&lang=js"

import "./Component-Select.vue?vue&type=style&index=0&id=bfd8d940&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd8d940"]])

export default __exports__